export default __webpack_public_path__ + "static/media/conversao.99c07e77.jpg";